'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import UITextInput from 'UIComponents/input/UITextInput';
const CLASS_NAME = 'CodeMirror-hs-textinput';
export default class TextInput extends Component {
  render() {
    const className = classNames(CLASS_NAME, this.props.className);
    return /*#__PURE__*/_jsx(UITextInput, Object.assign({}, this.props, {
      className: className
    }));
  }

}
TextInput.propTypes = {
  className: PropTypes.string
};